import * as fromDatatype from '../datatype-library';

export interface bl_inv_opdg_element_by_item_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    opdg_element_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    qty_allocated: fromDatatype.NumericDatatypeInterface;
    qty_ai_recommended: fromDatatype.NumericDatatypeInterface;
    qty_calculation: fromDatatype.NumericDatatypeInterface;
    qty_existing_stock_available_qty: fromDatatype.NumericDatatypeInterface;
    qty_to_replenish: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;    
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_opdg_element_by_item_hdr_RowClass implements bl_inv_opdg_element_by_item_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    opdg_element_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    qty_allocated: fromDatatype.NumericDatatypeInterface;
    qty_ai_recommended: fromDatatype.NumericDatatypeInterface;
    qty_calculation: fromDatatype.NumericDatatypeInterface;
    qty_existing_stock_available_qty: fromDatatype.NumericDatatypeInterface;
    qty_to_replenish: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;    
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
